
import { ClosedPeriod } from "@/models/base/closed-period";
import { ClosedPeriodService } from "@/services/closed-period-service";
import Vue from "vue";
import { BookYearService } from "@/services";

export default Vue.extend({
	data(){
		return {
			periods: [] as ClosedPeriod[],
			closedPeriods: [] as ClosedPeriod[],
			ClosedPeriodService
		};
	},
	methods: {
		async deletePeriod(period:ClosedPeriod){
			await ClosedPeriodService.deleteClosedPeriod(period);
		},
		async togglePeriod(period:ClosedPeriod, value:boolean){
			let foundPeriod = this.closedPeriods.find(p=>p.AccountingPeriod == period.AccountingPeriod);
			if (foundPeriod && !value){
				await this.deletePeriod(foundPeriod);
				return;
			}
			if (!value) return;
			period.setYearAndDateFromAccountingPeriod();
			await ClosedPeriodService.createClosedPeriod(period);
		},
		isPeriodClosed(period:ClosedPeriod):boolean {
			for (let p of this.closedPeriods) {
				if (period.AccountingPeriod == p.AccountingPeriod) {
					return true;
				}
			}
			return false;
		}
	},
	created(){
		for (let i = 1; i <= 12; i++) {
			let period = new ClosedPeriod();
			period.AccountingPeriod = i;
			period.setYearAndDateFromAccountingPeriod();
			period.BookYear = BookYearService.selectedBookYear;
			this.periods.push(period);
		}
		this.closedPeriods = this.ClosedPeriodService.getClosedPeriods();
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
